export function getLocalDateString(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function toDateOnly(value) {
  if (!value) return null;
  const text = String(value).slice(0, 10);
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function getDaysUntilService(serviceDate, cancelDate = getLocalDateString()) {
  const service = toDateOnly(serviceDate);
  const cancel = toDateOnly(cancelDate);
  if (!service || !cancel) return null;
  return Math.round((service.getTime() - cancel.getTime()) / 86400000);
}

export function getKakaoRefundPolicy(serviceDate, cancelDate = getLocalDateString()) {
  const daysUntilService = getDaysUntilService(serviceDate, cancelDate);
  let refundRate = 0;

  if (daysUntilService === null) {
    refundRate = 0;
  } else if (daysUntilService >= 7) {
    refundRate = 100;
  } else if (daysUntilService >= 4) {
    refundRate = 50;
  } else {
    refundRate = 0;
  }

  const description =
    daysUntilService === null
      ? "운행일을 확인하지 못해 환불률을 자동 계산하지 못했습니다."
      : `운행일 ${daysUntilService}일 전 취소로 예약금의 ${refundRate}% 환불 대상입니다.`;

  return {
    cancelDate,
    serviceDate: serviceDate ? String(serviceDate).slice(0, 10) : null,
    daysUntilService,
    refundRate,
    description,
    policyText: "환불 기준: 7일 이전 100%, 4~6일 이전 50%, 1~3일 이전 0%",
  };
}
